"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventDefault = void 0;
function preventDefault(callback) {
    return (e) => {
        if (e)
            e.preventDefault();
        callback(e);
    };
}
exports.preventDefault = preventDefault;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/preventDefault.ts
// module id = 554
// module chunks = 0 1 2